import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import AmbientBackground from '../ui/AmbientBackground';
import LoadingScreen from '../ui/LoadingScreen';
import PageTransition from '../ui/PageTransition';
import Splash from '../brand/Splash';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'auto' }); }, [pathname]);
  return null;
};

const Layout: React.FC = () => {
  const location = useLocation();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Splash />
      <AmbientBackground />
      <ScrollToTop />
      <Header />
      <Box component="main" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <AnimatePresence mode="wait" initial={false}>
          <PageTransition key={location.pathname}>
            <Suspense fallback={<LoadingScreen fullscreen />}>
              <Outlet />
            </Suspense>
          </PageTransition>
        </AnimatePresence>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
